/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPromoCode_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"TradePromo_viewer">;
    readonly " $refType": "PdpSharedPromoCode_viewer";
};
export type PdpSharedPromoCode_viewer$data = PdpSharedPromoCode_viewer;
export type PdpSharedPromoCode_viewer$key = {
    readonly " $data"?: PdpSharedPromoCode_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedPromoCode_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_viewer",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'f63fa07c219aacd664a081e71e472814';
export default node;
